// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  effectId: __t.string().name("effect_id"),
  effectType: __t.string().name("effect_type"),
  sourceId: __t.string().name("source_id"),
  targetId: __t.string().name("target_id"),
  skillId: __t.string().name("skill_id"),
  damage: __t.i32(),
  expiresAtTick: __t.option(__t.i64()).name("expires_at_tick"),
  hidden: __t.bool(),
});
